'use client'

import { useState } from 'react'
import { signOut } from '@/shared/ui/providers/AuthSessionProvider'
import { Home } from 'react-feather'
import { useLocale, useTranslations } from '@/lib/next-shim'

import { useGetMyInfosQuery } from '@/core/graphql/hooks'

import { AccountCircleIcon, CloseRoundedIcon, LanguageIcon, LogoutRoundedIcon } from '@/components/external/icons-material'
import { IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Stack, SwipeableDrawer } from '@/components/external/material'
import { LanguageSelectionDialog } from '@/shared/ui/dialog/LanguageSelectionDialog'
import LinkListItemButton from '@/components/external/material/LinkListItemButton'

function toPascalCase(str: string) {
  return str
    .toLowerCase() // Convert the string to lowercase
    .split(' ') // Split the string into an array of words
    .map((word) => {
      // For each word, capitalize the first letter
      return word[0].toUpperCase() + word.slice(1)
    })
    .join(' ') // Join the array of words back into a single string
}

export function AccountMenu() {
  const lang = useLocale()
  const t = useTranslations()

  const [drawerOpen, setDrawerOpen] = useState(false)
  const [languageSelectionDialogOpen, setLanguageSelectionDialogOpen] = useState(false)

  const { data } = useGetMyInfosQuery()
  const myInfos = data?.myInfos

  if (!myInfos) return null

  return (
    <div>
      <IconButton data-testid="user-menu-button" aria-label={t('button.dashboard.label')} onClick={() => setDrawerOpen(true)}>
        <AccountCircleIcon aria-hidden="true" />
      </IconButton>
      <SwipeableDrawer
        anchor="right"
        disableBackdropTransition
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onOpen={() => setDrawerOpen(true)}
        PaperProps={{ className: 'w-full max-w-xs' }}
        disableDiscovery={true}
      >
        <Stack direction="row" justifyContent="end" p={1}>
          <IconButton aria-label="Close menu" onClick={() => setDrawerOpen(false)}>
            <CloseRoundedIcon aria-hidden="true" />
          </IconButton>
        </Stack>
        <Stack className="flex-1">
          <div className="pt-4 px-4">
            <div className="py-2 pr-8 text-xl font-medium">
              {myInfos.userInfo.name} {myInfos.userInfo.surname}
            </div>
          </div>
          <List component="div" className="border-0 border-b border-solid border-slate-900/10">
            <ListItem component="div" disablePadding>
              <LinkListItemButton href="/account/dashboard">
                <ListItemIcon>
                  <Home />
                </ListItemIcon>
                {/* list item text should respecy camel case */}

                <ListItemText primary={toPascalCase(t('button.dashboard.label'))} />
              </LinkListItemButton>
            </ListItem>
          </List>
          <List component="div">
            <ListItem component="div" disablePadding>
              <ListItemButton onClick={() => setLanguageSelectionDialogOpen(true)}>
                <ListItemIcon>
                  <LanguageIcon />
                </ListItemIcon>
                <ListItemText primary={toPascalCase(lang)} />
              </ListItemButton>
            </ListItem>
            <ListItem component="div" disablePadding>
              <ListItemButton data-testid="logout-button" onClick={() => signOut()}>
                <ListItemIcon>
                  <LogoutRoundedIcon />
                </ListItemIcon>
                <ListItemText primary={toPascalCase(t('button.signOut.label'))} />
              </ListItemButton>
            </ListItem>
          </List>
        </Stack>
      </SwipeableDrawer>
      <LanguageSelectionDialog fullScreen open={languageSelectionDialogOpen} onClose={() => setLanguageSelectionDialogOpen(false)} />
    </div>
  )
}
